import React from 'react';
import logo from '../assets/Images/wglogo.svg'
import { Link } from 'react-router-dom';
// import { Button } from "@material-tailwind/react";

const Title = (props) => {
    const cardClassName =  'sub-headings' ;

  const combinedClassName = `${cardClassName}   ${props.className}`;


    return (

        <div className={combinedClassName}>
                <h3 className='allura title red'>{props.header}</h3>
                <h2 className='bebas title text-black'>{props.body}</h2>
            </div>


    );

}

export default Title;